import { useLang } from '@/i18n';
import EfNav from '@elem/ui/ef-nav';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');
    const list = [
        {
            href: '#ID-SectionA',
            title: t('nav_title_1'),
        },
        {
            href: '#ID-SectionB',
            title: t('nav_title_2'),
        },
        {
            href: '#ID-SectionC',
            title: t('nav_title_3'),
        },
        {
            href: '#ID-SectionD',
            title: t('nav_title_4'),
        },
    ];
    return <EfNav list={list} />;
}
